import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const Occupancy = loadable(() => import(/* webpackChunkName: "Occupancy" */ './Occupancy'), {
  fallback: <LoadableFallback visible />,
});

const asyncOccupancy = ({ route }) => (
  <Occupancy route={route} />
);

asyncOccupancy.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncOccupancy;
